'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('oAuthSvc', oAuthSvc);

  oAuthSvc.$inject = ['$q', 'msAuth', 'authenticationSvc'];

  /* @ngInject */
  function oAuthSvc($q, msAuth, authenticationSvc) {
    return {
      oauthSetup: oauthSetup
    };

    function oauthSetup(ticket) {
      // This response has two forms:
      // 1. returns a successful login with a JWT
      // 2. Returns a shell of a user signup to seed the signup process
      return msAuth.oauth(ticket).then(function (resp) {
        if (resp.data.type === 'LOGIN') {
          var respData;
          if (resp.data) {
            respData = resp.data;
            resp.data = resp.data.loginView;
          }
          // authenticationSvc.verifyLoggedInUserResponse expects a response with the loginView as the data
          // so we've mutated the object for processing
          authenticationSvc.verifyLoggedInUserResponse(resp, 'user-oauth-login');
          return respData;
        } else if (resp.data.type === 'SIGNUP') {
          var userPartial = resp.data.signupView;
          userPartial.oauthTicket = ticket;
          return resp.data;
        }
        return $q.reject();
      });
    }
  }
})();